import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { initAnalytics } from '../analytics';


const CookieBannerContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #333;
  color: white;
  padding: 15px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  font-size: 0.9rem;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
  }
`;

const CookieText = styled.p`
  margin: 0 0 10px 0;
  text-align: center;
  flex-grow: 1;

  @media (min-width: 768px) {
    margin: 0;
    text-align: left;
    margin-right: 20px;
  }

  a {
    color: #007bff;
    text-decoration: underline;
    margin-left: 5px;

    &:hover {
      color: #66b3ff;
    }
  }
`;

const CookieButtons = styled.div`
  display: flex;
  gap: 10px;
`;

const CookieButton = styled.button`
  background-color: #007bff;
  color: white;
  border: none;
  padding: 8px 15px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #0056b3;
  }

  &.decline {
    background-color: #6c757d;

    &:hover {
      background-color: #5a6268;
    }
  }
`;

const CONSENT_KEY = 'gdpr_cookie_consent';
// Recommandation CNIL : redemander le choix au bout de 6 mois
const CONSENT_DUREE_MS = 6 * 30 * 24 * 60 * 60 * 1000;

// Lit le choix enregistré : 'accepted', 'declined', ou null si absent / expiré.
// Les anciens choix sans date (simple texte) sont considérés comme expirés.
const lireConsentement = () => {
  try {
    const { choix, date } = JSON.parse(localStorage.getItem(CONSENT_KEY));
    return Date.now() - date < CONSENT_DUREE_MS ? choix : null;
  } catch (e) {
    return null;
  }
};

const enregistrerConsentement = (choix) => {
  try {
    localStorage.setItem(CONSENT_KEY, JSON.stringify({ choix, date: Date.now() }));
  } catch (e) {
    // stockage indisponible : le bandeau réapparaîtra à la prochaine visite
  }
};

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = lireConsentement();

    if (consent === 'accepted') {
      // L'utilisateur a déjà accepté -> On active le tracking
      initAnalytics();
    } else if (consent === 'declined') {
      // L'utilisateur a refusé -> On ne fait rien, tracking reste inactif
    } else {
      // Pas de choix (ou choix expiré) -> On affiche la bannière
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    enregistrerConsentement('accepted');
    setShowBanner(false);

    // Activation immédiate du tracking
    initAnalytics();
  };

  const handleDecline = () => {
    enregistrerConsentement('declined');
    setShowBanner(false);
    // On n'active PAS le tracking. La paix est préservée.
  };

  if (!showBanner) {
    return null;
  }

  return (
    <CookieBannerContainer>
      <CookieText>
        Avec votre accord, nous utilisons des cookies de mesure d'audience (Google Analytics) pour savoir comment le site est utilisé et l'améliorer. Vous pouvez accepter ou refuser, le site fonctionne de la même façon. Pour en savoir plus, consultez notre
        <Link to="/politique-confidentialite">Politique de Confidentialité</Link>.
      </CookieText>
      <CookieButtons>
        <CookieButton onClick={handleAccept}>Accepter</CookieButton>
        <CookieButton className="decline" onClick={handleDecline}>Refuser</CookieButton>
      </CookieButtons>
    </CookieBannerContainer>
  );
};

export default CookieBanner;
